import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);

    /**
     * Fallback for browsers where the declarative `on:click="/open"` handler
     * fails to bind (e.g. after hydration issues). Ensures the cart icon
     * always opens the drawer.
     */
    const trigger = this.querySelector('[on\\:click="/open"], [data-cart-open]');
    if (trigger) {
      trigger.addEventListener('click', this.#handleTriggerClick);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);

    const trigger = this.querySelector('[on\\:click="/open"], [data-cart-open]');
    if (trigger) {
      trigger.removeEventListener('click', this.#handleTriggerClick);
    }
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  #handleTriggerClick = (event) => {
    event.preventDefault();
    this.open();
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
